import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { SimpleField } from '../../abstracts/simple-field';

@Component({
  selector: 'fb-rating-field',
  templateUrl: './rating-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingFieldComponent extends SimpleField<number> {
  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Self()
    protected override ngControl: NgControl,
  ) {
    super(changeDetectorRef, ngControl);
  }

  setRating(rating: number): void {
    this.value = rating;
  }
}
